import {createStore,combineReducers,applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'
import {userLoginReducer,userDetailsReducer,userUpdateProfileReducer} from './reducers/userReducers'
import {videoListReducer} from './reducers/videoReducers'



const reducer = combineReducers({

    videoList:videoListReducer,
    userLogin:userLoginReducer,
    userDetails : userDetailsReducer,
    userUpdateProfile:userUpdateProfileReducer,

})


const userInfoFromStorage = localStorage.getItem('userInfo') ?
    JSON.parse(localStorage.getItem('userInfo')) : null

//cart state的資料源自於localstorage
const initialState = {
    userLogin: {userInfo:userInfoFromStorage}
}


const middleware= [thunk]

const store = createStore(reducer,initialState,
    composeWithDevTools(applyMiddleware(...middleware)))

export default store